"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePage = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _lodash = _interopRequireDefault(require("lodash"));

var _types = require("../../types");

var _rules = require("../rules");

var _index = require("../index");

var _config = require("../../components/config");

var _keyHelpers = require("../../utils/keyHelpers");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var FieldError = _flowRuntime["default"].tdz(function () {
  return _types.FieldError;
});

var OptionsComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionsComponentElementDefinition;
});

var PageDefinition = _flowRuntime["default"].tdz(function () {
  return _types.PageDefinition;
});

var InheritedComponentValidation = _flowRuntime["default"].tdz(function () {
  return _types.InheritedComponentValidation;
});

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _types.InheritedFieldValidation;
});

var excludedElements = _flowRuntime["default"].type("excludedElements", _flowRuntime["default"].object(_flowRuntime["default"].property("fieldKeys", _flowRuntime["default"].array(_flowRuntime["default"].string())), _flowRuntime["default"].property("componentKeys", _flowRuntime["default"].array(_flowRuntime["default"].string()))));

var validateField = function validateField(field, data, compositeFieldKey, inheritedFieldValidation) {
  var inheritedFieldRules = (0, _index.getInheritedFieldValidation)(field.key, inheritedFieldValidation);
  var rules = (0, _rules.getFieldValidationRules)(field, inheritedFieldRules);
  return _lodash["default"].compact( // The additional parameters are passed as we are using the Validator type from redux-form,
  // which specifies required props and name parameters we're not using here
  rules.map(function (rule) {
    var error = rule(_lodash["default"].get(data, compositeFieldKey), data, {}, '');
    return error && {
      key: compositeFieldKey,
      error: error
    };
  }));
};

var getExcludedKeysForComponent = function getExcludedKeysForComponent(component) {
  var excludedFields = function excludedFields(object) {
    var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (// $FlowFixMe WEB-352
      _lodash["default"].reduce(object, function (keys, v, k) {
        if ((0, _typeof2["default"])(v) === 'object') {
          return [].concat((0, _toConsumableArray2["default"])(keys), (0, _toConsumableArray2["default"])(excludedFields(v, (0, _keyHelpers.compositeKey)(parentKey, k))));
        }

        if (v !== true) {
          return [].concat((0, _toConsumableArray2["default"])(keys), [(0, _keyHelpers.compositeKey)(parentKey, k)]);
        }

        return keys;
      }, [])
    );
  };

  var excludedComponents = function excludedComponents(object) {
    var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return _lodash["default"].compact( // $FlowFixMe WEB-352
    _lodash["default"].reduce(object, function (keys, v, k) {
      if ((0, _typeof2["default"])(v) === 'object') {
        var componentOptions = v.options || v;
        var isExcluded = componentOptions.displayed ? !componentOptions.displayed : true;
        return [].concat((0, _toConsumableArray2["default"])(keys), [isExcluded && (0, _keyHelpers.compositeKey)(parentKey, k)], (0, _toConsumableArray2["default"])(excludedComponents(componentOptions, (0, _keyHelpers.compositeKey)(parentKey, k))));
      }

      return keys;
    }, []));
  };

  if (!component.options) {
    return {
      fieldKeys: [],
      componentKeys: []
    };
  }

  return {
    fieldKeys: excludedFields(component.options, component.key),
    componentKeys: excludedComponents(component.options, component.key)
  };
};

var validateComponent = function validateComponent(component, data) {
  var compositeComponentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : component.key;
  var excluded = arguments.length > 3 ? arguments[3] : undefined;
  var inheritedComponentValidation = arguments.length > 4 ? arguments[4] : undefined;
  var inheritedFieldValidation = arguments.length > 5 ? arguments[5] : undefined;
  var componentConfig = (0, _config.getComponentConfig)(component);

  if (!componentConfig) {
    var componentType = component.type || 'unknown';
    return [{
      key: compositeComponentKey,
      error: "Component type ".concat(componentType, " not recognised. Validation will fail until it is added to the component config in the components library.")
    }];
  }

  var excludedKeys = excluded || getExcludedKeysForComponent(component);
  var componentExcluded = excludedKeys.componentKeys.includes(compositeComponentKey);

  if (componentExcluded) {
    return [];
  }

  var inheritedComponentRules = (0, _index.getInheritedComponentValidation)(component.key, inheritedComponentValidation);
  var componentRules = (0, _rules.getComponentValidationRules)(component, compositeComponentKey, inheritedComponentRules);

  var componentErrors = _lodash["default"].compact( // The additional parameters are passed as we are using the Validator type from redux-form,
  // which specifies required props and name parameters we're not using here
  componentRules.map(function (rule) {
    var error = rule(null, data, {}, '');
    return error && {
      key: compositeComponentKey,
      error: error
    };
  }));

  var subComponents = _lodash["default"].get(componentConfig, 'subComponents', []);

  var subComponentErrors = _lodash["default"].flatten(subComponents.map(function (c) {
    return validateComponent(c, data, (0, _keyHelpers.compositeKey)(compositeComponentKey, c.key), excludedKeys, component.inheritedComponentValidation || [], component.inheritedFieldValidation || []);
  })); // e.g. in a fieldset the fields are declared as a 'fields' property in the constructed form json, not the in-code config


  var dynamicFields = _lodash["default"].get(component, 'fields', []);

  var dynamicFieldErrors = _lodash["default"].flatten(dynamicFields.map(function (f) {
    return validateField(f, data, (0, _keyHelpers.compositeKey)(compositeComponentKey, f.key), component.inheritedFieldValidation || []);
  }));

  var subFields = _lodash["default"].get(componentConfig, 'fields', []).map(function (f) {
    var isFieldExcluded = excludedKeys.fieldKeys.includes("".concat(compositeComponentKey, ".").concat(f.key));
    return isFieldExcluded ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, f), {}, {
      validation: []
    }) : f;
  });

  var componentInheritedFieldValidation = component.inheritedFieldValidation || [];
  var parentInheritedFieldValidation = inheritedFieldValidation || [];
  var combinedInheritedFieldRules = [].concat((0, _toConsumableArray2["default"])(componentInheritedFieldValidation), (0, _toConsumableArray2["default"])(parentInheritedFieldValidation));

  var subFieldErrors = _lodash["default"].flatten(subFields.map(function (f) {
    return validateField(f, data, (0, _keyHelpers.compositeKey)(compositeComponentKey, f.key), combinedInheritedFieldRules);
  }));

  return [].concat((0, _toConsumableArray2["default"])(componentErrors), (0, _toConsumableArray2["default"])(subComponentErrors), (0, _toConsumableArray2["default"])(dynamicFieldErrors), (0, _toConsumableArray2["default"])(subFieldErrors));
}; // eslint-disable-next-line import/prefer-default-export


var validatePage = function validatePage(page, data) {
  return _lodash["default"].flatMap(page.components, function (component) {
    return validateComponent(component, data);
  });
};

exports.validatePage = validatePage;